import { useState } from "react"

import { ParadiseDeleteQuoteDialog } from "src/components/Paradise/ParadiseQuotes/ParadiseDeleteQuoteDialog"
import { ParadiseQuoteGenerateLinkDialog } from "src/components/Paradise/ParadiseQuotes/ParadiseQuoteDetails/ParadiseQuoteGenerateLink"
import { DropdownListButton, IOption } from "src/ui/Button/DropdownListButton"

export function ParadiseQuoteActions({ quoteId }: { quoteId: string }) {
  const [showDeleteDialog, setShowDeleteDialog] = useState(false)
  const [showGenerateLinkDialog, setShowGenerateLinkDialog] = useState(false)

  const options: IOption<"delete-quote" | "get-link">[] = [
    {
      name: "Get link",
      value: "get-link",
      onClick: () => {
        setShowGenerateLinkDialog(true)
      },
    },
    {
      name: "Delete quote",
      value: "delete-quote",
      onClick: () => {
        setShowDeleteDialog(true)
      },
      color: "destructive",
    },
  ]

  return (
    <div>
      <DropdownListButton displayValue="Quote actions" options={options} />

      <ParadiseDeleteQuoteDialog
        open={showDeleteDialog}
        onClose={() => setShowDeleteDialog(false)}
        quoteId={quoteId}
      />

      <ParadiseQuoteGenerateLinkDialog
        open={showGenerateLinkDialog}
        onClose={() => setShowGenerateLinkDialog(false)}
        quoteId={quoteId}
      />
    </div>
  )
}
